export default "__VITE_ASSET__13f96ef6__"